import { useLocation, useNavigate } from 'react-router-dom';
import { useContext } from 'react';
import { FirebaseContext } from '@/session/FirebaseContext';
import { landingPathForUser } from '@/helpers/auth/landingRoutes';

export function useSiteLogoClick() {
  const navigate = useNavigate();
  const location = useLocation();
  const ctx = useContext(FirebaseContext);

  return () => {
    const home = landingPathForUser(Boolean(ctx.user));
    if (location.pathname === home || location.pathname === '/' || location.pathname === '/home') {
      window.location.reload();
      return;
    }
    navigate(home);
  };
}
